import React from 'react';
import './FormField.less';

type Props = {
  children: React.ReactNode;
};

function FormField({ children }: Props) {
  return <div className="form-field">{children}</div>;
}

export default FormField;
